<template>
  <div>
    <TrusteeInfo
      v-if="fillType === SubjectFillType.MANUAL"
      :trustee-info-prop="trusteeInfo"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </TrusteeInfo>

    <Assignee
      v-if="fillType === SubjectFillType.ASSIGNEE"
      :assignee-prop="assignee"
      :field-group="FieldGroup.PERSON"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </Assignee>
  </div>
</template>

<script>
import { SubjectFillType } from '@/constants';
import TrusteeInfo from './TrusteeInfo';
import Assignee from '@/views/alternativeServices/AddStApplicant/ManualTrustee/EgrnTrustee/Assignee';
import { FieldGroup } from '@/utils/fullStatementView';

export default {
  name: 'Person',
  components: {
    TrusteeInfo,
    Assignee,
  },
  props: {
    trusteeInfo: {
      type: Object,
    },
    assignee: {
      type: Object,
    },
    fillType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    FieldGroup,
    SubjectFillType,
  }),
};
</script>
